import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import * as Yup from "yup";
import { ControlState } from "../models/flexible/control-state";
import { renderRequiredMessage } from "../utils/render-required-message";
import { GeneralFieldController } from "./general-field-controller";

export class DiscontinuationDateFieldController extends GeneralFieldController {
	override createValidationRule(initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return (super.createFieldValidationRuleByDataType(translation) as Yup.DateSchema)
			.max(new Date(), translation("cannot-be-greater-than-today"))
			.when([AttributeIdentifiers.PatientEnrolledInTreatment], ((isEnrolled: boolean | string, schema: Yup.DateSchema<any>) =>
				!isEnrolled || `${isEnrolled}` === "false"
					? schema.required(renderRequiredMessage(this.schema.attribute.identifier, translation))
					: schema) as any);
	}

	override useControlProps(path: string) {
		return {
			cannotBeFuture: true,
		};
	}

	override useControlState(): ControlState {
		const [isPatientEnrolledInTreatment] = useFieldValue(AttributeIdentifiers.PatientEnrolledInTreatment);
		return `${isPatientEnrolledInTreatment}` === "false" ? "enabled" : "hidden";
	}
}
